import { Fragment, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Seo from '../headers/seo';
import FullpageAnimatedLogo from '../ui/Loading/FullpageAnimatedLogo';

const Layout = () => {
  const { t } = useTranslation('common');

  return (
    <Fragment>
      <Seo
        title={t('common:seo.title')}
        description={t('common:seo.description')}
        keywords={t('common:seo.keywords')}
      />

      <main id='main'>
        <Suspense fallback={<FullpageAnimatedLogo />}>
          <Outlet />
        </Suspense>
      </main>
    </Fragment>
  );
};

export default Layout;
